import React, { useEffect, useRef } from 'react';
import { Animated, Easing } from 'react-native';
import { Icons, XStack } from '@usepepper/sprout-kit-ui';

const CHEVRON_ROTATION_DURATION_MS = 220;

interface OrderEntryMobileHeaderChevronProps {
  isExpanded: boolean;
}

export const OrderEntryMobileHeaderChevron: React.FC<
  OrderEntryMobileHeaderChevronProps
> = ({ isExpanded }) => {
  const rotation = useRef(new Animated.Value(isExpanded ? 1 : 0)).current;

  useEffect(() => {
    const animation = Animated.timing(rotation, {
      duration: CHEVRON_ROTATION_DURATION_MS,
      easing: Easing.out(Easing.cubic),
      toValue: isExpanded ? 1 : 0,
      useNativeDriver: true,
    });

    animation.start();

    return () => animation.stop();
  }, [isExpanded, rotation]);

  return (
    <Animated.View
      style={{
        transform: [
          {
            rotate: rotation.interpolate({
              inputRange: [0, 1],
              outputRange: ['0deg', '180deg'],
            }),
          },
        ],
      }}
    >
      <XStack
        alignItems="center"
        backgroundColor="$bgSecondaryDefault"
        borderRadius="$round"
        height="$32"
        justifyContent="center"
        width="$32"
      >
        <Icons.ChevronDown color="$iconSecondary" size={17} />
      </XStack>
    </Animated.View>
  );
};
